var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "result" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 profile-image-container" }, [
        _c("a", { attrs: { href: _vm.talent.profile.url } }, [
          _c("img", { attrs: { src: _vm.talent.profile_image_url, alt: "" } }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "checkbox checkbox-talent" }, [
          _c("input", {
            attrs: { type: "checkbox", id: `checkbox-${_vm.talent.id}` },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleTag.apply(null, arguments)
              },
            },
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: `checkbox-${_vm.talent.id}` } }, [
            _vm.tagStatus
              ? _c("span", { staticClass: "tagged" }, [
                  _c("i", { staticClass: "fa fa-check" }),
                  _vm._v(" Tagged\n        "),
                ])
              : _c("span", [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v(" Tag\n        "),
                ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12" }, [
        _c("a", { staticClass: "details" }, [
          _c("div", { staticClass: "main" }, [
            _c("h2", [
              _vm._v(_vm._s(_vm.talent.first_name)),
              _c("br"),
              _vm._v(" " + _vm._s(_vm.talent.last_name)),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }